


































































import { Subscription } from 'rxjs';
import { Component, Prop, Inject, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon, IconConfig } from '../sw-icon';
import SwTopNav from './sw-top-nav.vue';
import { ProvidedTopNavParam } from './types';

const cssPrefix = 'sw-top-nav-item';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwTopNavItem extends SwExtendedVue {
  @Prop({ type: String, required: true })
  itemId: string;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  dim: boolean;

  @Prop({ type: Object, required: true })
  icon: IconConfig;

  @Prop({ type: String, required: true })
  label: string;

  cssPrefix =  cssPrefix;
  eventSubscription: Subscription | null = null;

  @Inject()
  readonly navParam: ProvidedTopNavParam;

  get effectiveIconConfig(): IconConfig {
    return Object.assign(this.icon, {
      size: 18,
      asBlock: true,
    } as IconConfig);
  }

  @Inject()
  private claimSelectNavItem: SwTopNav['claimSelectNavItem'];

  @Inject()
  private claimHighlightReferrer: SwTopNav['claimHighlightReferrer'];

  @Watch('selected')
  private checkClaimHighlight() {
    if (!this.selected) { return; }
    if (!this.$refs.icon) { return; }
    const iconComp = this.$refs.icon as HTMLElement;
    const rect = iconComp.getBoundingClientRect();
    this.claimHighlightReferrer(this.itemId, {
      top: rect.top,
      left: rect.left,
      right: rect.right,
      bottom: rect.bottom,
      width: rect.width,
      height: rect.height,
    });
  }

  private onClick() {
    if (this.disabled) { return; }
    if (this.navParam.mode === 'expand') {
      this.claimSelectNavItem(this.itemId);
    }
  }

  private created() {
    this.eventSubscription = this.navParam.eventbus.subscribe((event) => {
      if (event !== 'request-check-highlight-referrer') { return; }
      this.checkClaimHighlight();
    });
  }

  private mounted() {
    this.checkClaimHighlight();
  }

  private beforeDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
      this.eventSubscription = null;
    }
  }
}
